/**
 * First-party page-view ping. One ping per full page load is enough to give
 * the Lead CRM dashboard a real "Visitors" count instead of the internal
 * registration/audit-log heuristic — no route-level granularity needed yet.
 */

import api from "./api";
import { getFirstTouchAttribution } from "../utils/attributionCapture";

const SESSION_KEY = "nema_page_view_session_id_v1";

function getOrCreateSessionId() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    let sessionId = window.localStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      window.localStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return null;
  }
}

export function pingPageView() {
  try {
    const attribution = getFirstTouchAttribution();
    api.recordPageView({
      sessionId: getOrCreateSessionId(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
      utmSource: attribution?.utmSource || null,
      utmMedium: attribution?.utmMedium || null,
      utmCampaign: attribution?.utmCampaign || null,
      fbclid: attribution?.fbclid || null,
      gclid: attribution?.gclid || null,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
    });
  } catch {
    /* tracking must never break page load */
  }
}
